import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import { NotifierProvider } from "./components/Notifier";
import { ErrorBoundary } from "./ErrorBoundary";
import { MeProvider } from "./hooks/useMe";
import { Layout, PublicLayout } from "./Layout";
import { AddressFormPage } from "./pages/address-form";
import { CancelGuidePage } from "./pages/cancel-guide";
import { ContactPage } from "./pages/contact";
import { DashboardPage } from "./pages/dashboard";
import { ExternalMallContactPage } from "./pages/external-mall-contact";
import { LoginPage } from "./pages/login";
import { NotFoundPage } from "./pages/not-found";
import { OrderChangeFormPage } from "./pages/order-change-form";
import { OrderDetailPage } from "./pages/order-detail";
import { ReceiptPage } from "./pages/receipt";
import { ReturnFormPage } from "./pages/return-form";
import { VerifyPage } from "./pages/verify";

const router = createBrowserRouter(
  [
    {
      element: <PublicLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        { path: "login", element: <LoginPage /> },
        { path: "verify", element: <VerifyPage /> },
        // 未ログイン / ログイン後どちらからもリンクされるため PublicLayout 配下に置く。
        { path: "contact", element: <ContactPage /> },
        // モール (Amazon / 楽天 / Yahoo) でご購入の方向けのお問い合わせ導線。
        { path: "external-mall-contact", element: <ExternalMallContactPage /> },
      ],
    },
    {
      element: <Layout />,
      errorElement: <ErrorBoundary />,
      children: [
        { index: true, element: <Navigate to="/dashboard" replace /> },
        { path: "dashboard", element: <DashboardPage /> },
        { path: "orders/:code", element: <OrderDetailPage /> },
        { path: "orders/:code/cancel", element: <CancelGuidePage /> },
        { path: "orders/:code/change", element: <OrderChangeFormPage /> },
        { path: "orders/:code/address", element: <AddressFormPage /> },
        { path: "orders/:code/receipt", element: <ReceiptPage /> },
        { path: "orders/:code/return", element: <ReturnFormPage /> },
      ],
    },
    { path: "*", element: <NotFoundPage /> },
  ],
  { basename: "/mypage" },
);

const App = () => (
  <MeProvider>
    <NotifierProvider>
      <RouterProvider router={router} />
    </NotifierProvider>
  </MeProvider>
);

export default App;
